import { useTheme } from "@mui/material/styles";
import { useRef } from "react";

import { useGame } from "src/client/human/game/GameContext";
import "./AllPiecesView.css";
import { useAllPiecesScene } from "./useAllPiecesScene";

export function AllPiecesView() {
  const theme = useTheme();
  const game = useGame();
  const canvasHost = useRef<HTMLDivElement>(null);
  useAllPiecesScene(canvasHost, theme.palette.background.default, game);

  return <div ref={canvasHost} className="all-pieces-view" />;
}
